"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require("urql"),
  createClient = _require.createClient,
  gql = _require.gql,
  Client = _require.Client,
  cacheExchange = _require.cacheExchange,
  fetchExchange = _require.fetchExchange,
  subscriptionExchange = _require.subscriptionExchange;
var _require2 = require("graphql-ws"),
  createWSClient = _require2.createClient;
var _require3 = require("wonka"),
  pipe = _require3.pipe,
  _subscribe = _require3.subscribe;
var HasuraService = /*#__PURE__*/function () {
  function HasuraService(_ref) {
    var _this = this;
    var config = _ref.config,
      _ref$webSocket = _ref.webSocket,
      webSocket = _ref$webSocket === void 0 ? false : _ref$webSocket,
      auth = _ref.auth;
    (0, _classCallCheck2["default"])(this, HasuraService);
    (0, _defineProperty2["default"])(this, "_config", void 0);
    (0, _defineProperty2["default"])(this, "_auth", void 0);
    (0, _defineProperty2["default"])(this, "client", void 0);
    (0, _defineProperty2["default"])(this, "_createWSClient", function () {
      var wsClient = createWSClient({
        url: "wss://".concat(_this._config.get("gqlHost")),
        connectionParams: _this._fetchOptions.bind(_this)
      });
      return new Client({
        url: "https://".concat(_this._config.get("gqlHost")),
        fetchOptions: _this._fetchOptions.bind(_this),
        requestPolicy: "network-only",
        exchanges: [cacheExchange, fetchExchange, subscriptionExchange({
          forwardSubscription: _this._buildForwardSubscription(wsClient)
        })]
      });
    });
    (0, _defineProperty2["default"])(this, "_createAPIClient", function () {
      return createClient({
        url: "https://".concat(_this._config.get("gqlHost")),
        fetchOptions: _this._fetchOptions.bind(_this),
        requestPolicy: "network-only"
      });
    });
    this._config = config;
    this._auth = auth;
    this.client = webSocket ? this._createWSClient() : this._createAPIClient();
  }
  return (0, _createClass2["default"])(HasuraService, [{
    key: "_fetchOptions",
    value: function _fetchOptions() {
      return {
        headers: {
          authorization: "Bearer ".concat(this._auth.getToken())
        }
      };
    }
  }, {
    key: "_buildForwardSubscription",
    value: function _buildForwardSubscription(wsClient) {
      return function (request) {
        var input = _objectSpread(_objectSpread({}, request), {}, {
          query: request.query || ""
        });
        return {
          subscribe: function subscribe(sink) {
            var unsubscribe = wsClient.subscribe(input, sink);
            return {
              unsubscribe: unsubscribe
            };
          }
        };
      };
    }
  }, {
    key: "_buildQuery",
    value: function _buildQuery(query) {
      return gql(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n    "])), query);
    }
  }, {
    key: "query",
    value: function query(_ref2) {
      var data = _ref2.data,
        _query = _ref2.query;
      _query = this._buildQuery(_query);
      return this.client.query(_query, data).toPromise();
    }
  }, {
    key: "subscribe",
    value: function subscribe(onData, _ref3) {
      var data = _ref3.data,
        subscriptionQuery = _ref3.subscriptionQuery,
        _ref3$postProcess = _ref3.postProcess,
        postProcess = _ref3$postProcess === void 0 ? function (data) {
          return data;
        } : _ref3$postProcess;
      var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var processedSub = this._buildQuery(subscriptionQuery);
      var subscription = pipe(this.client.subscription(processedSub, data || {}), _subscribe(function (result) {
        if (onError && result !== null && result !== void 0 && result.error) {
          onError(result.error);
        } else if (result !== null && result !== void 0 && result.data) {
          onData(postProcess(result));
        }
      }));
      return subscription.unsubscribe;
    }
  }]);
}();
module.exports = HasuraService;